import React, { useEffect, useState, Suspense } from 'react';
import App from './App';
import MetaUpdater from './components/MetaUpdater';
import Prerender from './prerender';
import './css/app-stylesDDD.css';

/**
 * This is a wrapper component that includes both the main App
 * and the MetaUpdater to ensure proper metadata handling during pre-rendering.
 * 
 * It also includes a simple pre-renderable component that will be shown initially
 * and then replaced with the full app when the app is hydrated on the client.
 */

// Lazy load the main App component
const LazyApp = React.lazy(() => import('./App'));

const AppWrapper: React.FC = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // Use requestIdleCallback for non-critical initialization
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => {
        setIsClient(true);
      });
    } else {
      // Fallback for browsers that don't support requestIdleCallback
      setTimeout(() => {
        setIsClient(true);
      }, 0);
    }
  }, []);

  return (
    <>
      <MetaUpdater />
      
      {/* 
        Show the simple pre-renderable component during SSR/pre-rendering,
        and the full App component when in the browser
      */}
      {isClient ? (
        <Suspense fallback={<Prerender />}>
          <LazyApp />
        </Suspense>
      ) : (
        <Prerender />
      )}
    </>
  );
};

export default AppWrapper; 